import { useContext, useState, useEffect } from 'react';
import { UserContext } from "../context/user-context";
import { OfficesContext } from '../context/offices-context';
import Button from '../components/button';
import {useNavigate} from 'react-router-dom';
import FormInput from '../components/form-input';
import { getOfficeDocument, updateOfficeDocument } from '../utils/firebase';
import { useLocation } from 'react-router-dom'

const defaultFormFields = {
    name: '',
    short: '',
    chief: '',
    designation: '',
}

const UpdateOffice = () => {
    const navigate = useNavigate();
    const { currentUser } = useContext(UserContext);
    const { updateOfficeInContext } = useContext(OfficesContext);
    const location = useLocation();
    
    const id = location.pathname.replace("/offices/", "").replace("/update", "")

    const [formFields, setFormFields] = useState(defaultFormFields);
    const { name, short, chief, designation } = formFields;

    const resetFormFields = () => {
        setFormFields(defaultFormFields);
    }

    const handleChange = (event) => {
        const { id, value } = event.target;

        setFormFields({...formFields, [id]: value});
    }

    useEffect(() => {
        const getUser = async () => {
            const doc = await getOfficeDocument(id);
            setFormFields(doc);
        }
        getUser();
    }, []);


    const handleSubmit = async (event) => {
        event.preventDefault();

        const response = await updateOfficeDocument(id, formFields);
        if (response !== "success") {
            alert(response);
            return;
        }

        formFields["id"] = id;
        updateOfficeInContext(formFields);
        resetFormFields();
        navigate('/offices/' + id);
    }

    return (
        <div className='column'>
            <div className='columns main'>
                <div className='column is-8 is-offset-2'>
                    <h2 className='is-size-2 has-text-weight-bold my-6'>Update Account</h2>
                        <div className="block pb-6">
                                <form onSubmit={handleSubmit}>
                                    <div className='columns is-multiline'>
                                        <FormInput type="text" required id="name" value={name} onChange={handleChange} label="Office Name" additionalClasses="column is-6"/>
                                        <FormInput type="text" required id="short" value={short} onChange={handleChange} label="Office Acronym" additionalClasses="column is-6"/>
                                        <FormInput type="text" required id="chief" value={chief} onChange={handleChange} label="Name of Chief" additionalClasses="column is-6"/>
                                        <FormInput type="text" required id="designation" value={designation} onChange={handleChange} label="Designation of Chief" additionalClasses="column is-6"/>
                                    </div>

                                    <Button additionalClasses="block is-success" type="submit">Submit</Button>
                                </form>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default UpdateOffice;